import React from 'react'
import { Canvas } from './Canvas'
import { ClearCanvasButton } from './ClearCanvasButton';

function App() {
  return (
    <>
      <Canvas/>
      <ClearCanvasButton/>
    </>
  );
}

export default App;
